/** dayOfWeek: 1=Mon … 7=Sun (same as bulk create) */
export const CLASS_SESSION_DAYS_OF_WEEK = [
  { value: 1, label: "ຈັນ" },
  { value: 2, label: "ອັງຄານ" },
  { value: 3, label: "ພຸດ" },
  { value: 4, label: "ພະທັດ" },
  { value: 5, label: "ສຸກ" },
  { value: 6, label: "ເສົາ" },
  { value: 7, label: "ອາທິດ" },
] as const;

export function specDayOfWeekFromDateString(dateStr: string): number {
  const d = new Date(`${dateStr}T12:00:00`);
  const js = d.getDay();
  return js === 0 ? 7 : js;
}

export function formatDayOfWeekLabels(values: number[]): string {
  const map = new Map(
    CLASS_SESSION_DAYS_OF_WEEK.map((d) => [d.value, d.label]),
  );
  return values
    .slice()
    .sort((a, b) => a - b)
    .map((v) => map.get(v) ?? String(v))
    .join(", ");
}
